import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PlayMusic } from '../../../ui/icons';
import { useDispatch, useSelector } from "react-redux";
import { getMainVideo } from "../../../store/courseSlice";

const First = () => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch();
    const { mainVideo } = useSelector((state) => state.courses);

    useEffect(() => {
        dispatch(getMainVideo());
    }, [dispatch]);

    const styles = {
        img: {
            height: "calc(100vh - 74px)",
            backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.61), rgba(0, 0, 0, 0.61)), url('./images/Main/Background.png')",
            backgroundSize: "cover",
            backgroundPosition: "center"
        },
        wrapper: {
            height: '100%',
            flexDirection: 'column',
        },
        mainText: {
            letterSpacing: '1.2px',
            lineHeight: '110%',
            fontWeight: 600,
        }
    };

    return (
        <section>
            {isOpen ? (
                <div className="flex w-full items-center justify-center">
                    <div
                        className="relative w-full transform transition-all duration-300 ease-in-out scale-95">
                        <video width="100%" height="100%" autoPlay controls
                               className='w-full object-cover pb-5'>
                            <source src={mainVideo.introductory_video} type="video/mp4"/>
                            {t('video_not_supported')}
                        </video>
                    </div>
                </div>
            ) : (
                <div className='px-[20px] sm:px-[50px]' style={styles.img}>
                    <div style={styles.wrapper} className='flex items-center justify-between'>
                        <div></div>
                        <button onClick={() => setIsOpen(true)} className='cursor-pointer'>
                            <PlayMusic />
                        </button>
                        <div className="w-full">
                            <h1 className="text-white text-left text-[28px] font-semibold sm:text-4xl md:text-5xl lg:text-6xl pb-10 header-text">
                                {t('hero_section.title')}
                                {/* <span className="hidden md:hidden">{t('hero_section.mastery')}</span> */}
                                {/* <span className="inline md:inline block"> {t('hero_section.mastery')}</span> */}
                            </h1>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default First;